module.exports = __webpack_public_path__ + "media/images/pic/banners/stationary-courses-2a555f143bf5d59005b2e507fe0ffde4.jpeg";